import React, { useState, useEffect, useContext } from 'react';
import { Table, Form, message, Button, Tooltip, Select, Cascader, Modal, Radio } from 'antd';
import IconTip from '@/components/icon-tip';
import FilterBoxes from '@/components/filter-boxes';
import apis from '../apis';
import { filterConditions, formatPrice } from '@/common/utils';
import './index.less';
import ProviderUserTypeInfo from '../provider-userType-info';
import ModuleTitle from './module-title';

export default function ActivityDetailTable(props) {
  const value = useContext(ProviderUserTypeInfo);
  console.log('传递的参数', props);
  const { realTimeData = false, statisticsDimension = '0', platform, dt, planCode, startTime, endTime } = props;
  const [loading, setLoading] = useState(false);
  const [activityId, setActivityId] = useState();
  const [floorLoading, setFloorLoading] = useState(false);
  const [downloadType, setDownloadType] = useState(1);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    total: 0,
    values: [],
  });
  const [floorData, setFloorData] = useState([]);
  const [form] = Form.useForm();
  const [conditions, setConditions] = useState({
    pageNum: 1,
    pageSize: 10,
    ...value,
  });
  const [filterData, setFilterData] = useState({
    activityName: [],
    activityDept: [],
    activityErp: [],
  });

  useEffect(() => {
    setConditions((conditions) =>
      Object.assign({}, conditions, {
        realTimeData,
        statisticsDimension,
        platform,
        dt,
        planCode,
        pageNum: 1,
        startTime,
        endTime,
      })
    );
  }, [realTimeData, statisticsDimension, platform, planCode, dt, form, startTime, endTime]);

  const getColumns = () => {
    const columns = [
      {
        title: '会场信息',
        fixed: 'left',
        width: 200,
        render(record) {
          return (
            <div>
              <Tooltip title={record.activityName}>
                <div className="ellipsis-1-line">{record.activityName}</div>
              </Tooltip>
              <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.65)' }}>编号：{record.activityId || '-'}</div>
            </div>
          );
        },
      },
      {
        title: '活动名称',
        dataIndex: 'planName',
        width: 200,
        render(data) {
          return <span className="ellipsis-1-line">{data}</span>;
        },
      },
      {
        title: '日期',
        width: 150,
        render(record) {
          const { dt, hour, activityStartTime, activityEndTime } = record;
          // return dt + (hour ? ' ' + hour : '');
          if (!record.startTime) return dt;
          return (
            <>
              <div>{record.startTime + '~'}</div>
              <div>{record.endTime}</div>
            </>
          );
          // return statisticsDimension == '1' ? activityStartTime + '~' + activityEndTime : dt + (hour ? ' ' + hour : '');
        },
      },
      {
        title: (
          <>
            曝光sku数
            <IconTip title="活动会场中有曝光UV的sku数量去重" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'expSkuNums',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            点击sku数
            <IconTip title="通过活动会场有点击的sku数量去重" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'clickSkuNums',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            引商sku数
            <IconTip title="通过活动会场页面进入商详页面的sku去重数量（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'introSkuDetailSkuNums',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            直接引导成交sku数
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，成交的sku数为直接引导成交sku数" />
          </>
        ),
        width: 150,
        dataIndex: 'directiveIntroSkuNums',
        sorter: true,
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            sku点击率
            <IconTip title="点击sku数/曝光sku数" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'skuClickRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },

      {
        title: (
          <>
            sku动销率
            <IconTip title="直接引导成交sku数/曝光sku数" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'skuSaleRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },
      {
        title: (
          <>
            商品曝光PV
            <IconTip title="会场页面上商品曝光PV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'expPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品曝光UV
            <IconTip title="会场页面上商品曝光UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'expUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品点击PV
            <IconTip title="会场页面上商品点击PV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'clickPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品点击UV
            <IconTip title="会场页面上商品点击UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'clickUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            引入商详PV
            <IconTip title="通过活动会场页面进入商详页面的PV（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'introSkuDetailPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            引入商详UV
            <IconTip title="通过活动会场页面进入商详页面的UV去重（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 150,
        dataIndex: 'introSkuDetailUV',
        sorter: true,
        render: (data) => {
          return formatPrice(data);
        },
      },

      {
        title: (
          <>
            直接引导成交UV
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生下单行为的用户数为直接引导成交UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'directiveIntroUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            UV点击率
            <IconTip title="商品点击UV/商品曝光UV" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'uvClickRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },
      {
        title: (
          <>
            UV成交率
            <IconTip title="直接引导成交UV/商品点击UV" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'uvDealRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },
      {
        title: (
          <>
            直接引导成交订单金额
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单金额为直接引导成交订单金额" />
          </>
        ),
        width: 180,
        sorter: true,
        dataIndex: 'directiveIntroOrderValue',
        render: (data) => {
          return formatPrice(data);
        },
        sorter: true,
      },
      {
        title: (
          <>
            直接引导成交订单量
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单量为直接引导成交订单量" />
          </>
        ),
        width: 160,
        sorter: true,
        dataIndex: 'directiveIntroParentOrderNums',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            直接引导UV价值
            <IconTip title="直接引导成交订单金额/直接引导成交UV" />
          </>
        ),
        width: 160,
        sorter: true,
        dataIndex: 'directiveIntroUVValue',
        render: (data) => {
          return formatPrice(data);
        },
      },
    ];
    if (statisticsDimension == '1') {
      columns.splice(2, 1);
    }
    return columns;
  };

  useEffect(() => {
    if (!conditions.planCode) return;
    let didMount = true;
    setLoading(true);
    setActivityId(null);
    setFloorData([]);
    apis
      .getActivityDetailData(filterConditions(conditions))
      .then((res) => {
        if (!didMount) return;
        setLoading(false);
        const { ret, msg, data } = res;
        if (ret != 0 || !data) throw msg || '会场明细暂无数据';
        setData(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
    return () => {
      didMount = false;
    };
  }, [conditions]);

  useEffect(() => {
    apis
      .queryActivityScopeList(filterConditions({ ...value, planCode }))
      .then((res) => {
        const { ret, msg, data } = res;
        console.log('会场筛选数据', data);
        if (ret === '0') {
          setFilterData(data);
        } else {
          message.error(msg);
          setFilterData({
            activityName: [],
            activityDept: [],
            activityErp: [],
          });
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [value, planCode]);

  const onFinish = (val) => {
    console.log('查询会场参数', val);
    let buIdA, dept1IdA, dept2IdA, dept3IdA;
    if (val.dept) {
      buIdA = val.dept[0] ? [val.dept[0]] : undefined;
      dept1IdA = val.dept[1] ? [val.dept[1]] : undefined;
      dept2IdA = val.dept[2] ? [val.dept[2]] : undefined;
      dept3IdA = val.dept[3] ? [val.dept[3]] : undefined;
    }

    setConditions((conditions) =>
      Object.assign({}, conditions, {
        activityIds: val.activityIds,
        erpA: val.erpA,
        buIdA,
        dept1IdA,
        dept2IdA,
        dept3IdA,
        pageNum: 1,
      })
    );
  };

  const downLoad = async (params) => {
    if (params.type === 1) {
      try {
        const res = await apis.getActivityDetailData(params);
        const { ret, msg, data } = res;
        if (ret != 0) throw msg || '导出数据失败';
        message.success('已开始导出数据，导出成功后将发到您的咚咚和邮箱，请注意查收！');
      } catch (ex) {
        message.error(ex);
      }
    } else {
      try {
        const res = await apis.queryFloorList(params);
        const { ret, msg, data } = res;
        if (ret != 0) throw msg || '导出数据失败';
        message.success('已开始导出数据，导出成功后将发到您的咚咚和邮箱，请注意查收！');
      } catch (ex) {
        message.error(ex);
      }
    }
  };

  const queryFloorList = (param) => {
    apis.queryFloorList({ ...conditions, ...param }).then((res) => {
      const {
        ret,
        data: { values = [] },
        msg,
      } = res;
      setFloorLoading(false);
      if (ret === '0') {
        setFloorData(values);
      } else {
        setFloorData([]);
        message.error(msg);
      }
    });
  };

  const getfloorColumns = () => {
    const columns = [
      {
        title: '楼层信息',
        fixed: 'left',
        width: 200,
        render(record) {
          return (
            <div>
              <Tooltip title={record.floorName}>
                <div className="ellipsis-1-line">{record.floorName}</div>
              </Tooltip>
              <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.65)' }}>id：{record.floorId || '-'}</div>
            </div>
          );
        },
      },
      {
        title: '活动名称',
        dataIndex: 'planName',
        width: 200,
        render(data) {
          return <span className="ellipsis-1-line">{data}</span>;
        },
      },
      {
        title: '日期',
        width: 150,
        render(record) {
          const { dt, hour, activityStartTime, activityEndTime } = record;
          // return dt + (hour ? ' ' + hour : '');
          if (!record.startTime) return dt;
          return (
            <>
              <div>{record.startTime + '~'}</div>
              <div>{record.endTime}</div>
            </>
          );
          // return statisticsDimension == '1' ? activityStartTime + '~' + activityEndTime : dt + (hour ? ' ' + hour : '');
        },
      },
      {
        title: (
          <>
            曝光sku数
            <IconTip title="活动会场中有曝光UV的sku数量去重" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'expSkuNums',
        render: (data) => {
          return formatPrice(data);
        },
        sorter: {
          compare: (a, b) => a.expSkuNums - b.expSkuNums,
        },
      },
      {
        title: (
          <>
            点击sku数
            <IconTip title="通过活动会场有点击的sku数量去重" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'clickSkuNums',
        render: (data) => {
          return formatPrice(data);
        },
        sorter: {
          compare: (a, b) => a.clickSkuNums - b.clickSkuNums,
        },
      },
      {
        title: (
          <>
            引商sku数
            <IconTip title="通过活动会场页面进入商详页面的sku去重数量（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'introSkuDetailSkuNums',
        render: (data) => {
          return formatPrice(data);
        },
        sorter: {
          compare: (a, b) => a.introSkuDetailSkuNums - b.introSkuDetailSkuNums,
        },
      },
      {
        title: (
          <>
            直接引导成交sku数
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，成交的sku数为直接引导成交sku数" />
          </>
        ),
        width: 150,
        dataIndex: 'directiveIntroSkuNums',
        sorter: true,
        render: (data) => {
          return formatPrice(data);
        },
        sorter: {
          compare: (a, b) => a.directiveIntroSkuNums - b.directiveIntroSkuNums,
        },
      },
      {
        title: (
          <>
            sku点击率
            <IconTip title="点击sku数/曝光sku数" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'skuClickRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
        sorter: {
          compare: (a, b) => a.skuClickRate - b.skuClickRate,
        },
      },

      {
        title: (
          <>
            sku动销率
            <IconTip title="直接引导成交sku数/曝光sku数" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'skuSaleRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
        sorter: {
          compare: (a, b) => a.skuSaleRate - b.skuSaleRate,
        },
      },
      {
        title: (
          <>
            商品曝光PV
            <IconTip title="会场页面上商品曝光PV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'expPV',
        render: (data) => {
          return formatPrice(data);
        },
        sorter: {
          compare: (a, b) => a.expPV - b.expPV,
        },
      },
      {
        title: (
          <>
            商品曝光UV
            <IconTip title="会场页面上商品曝光UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'expUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品点击PV
            <IconTip title="会场页面上商品点击PV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'clickPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品点击UV
            <IconTip title="会场页面上商品点击UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'clickUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            引入商详PV
            <IconTip title="通过活动会场页面进入商详页面的PV（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'introSkuDetailPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            引入商详UV
            <IconTip title="通过活动会场页面进入商详页面的UV去重（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 150,
        dataIndex: 'introSkuDetailUV',
        sorter: true,
        render: (data) => {
          return formatPrice(data);
        },
      },

      {
        title: (
          <>
            直接引导成交UV
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生下单行为的用户数为直接引导成交UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'directiveIntroUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            UV点击率
            <IconTip title="商品点击UV/商品曝光UV" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'uvClickRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },
      {
        title: (
          <>
            UV成交率
            <IconTip title="直接引导成交UV/商品点击UV" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'uvDealRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },
      {
        title: (
          <>
            直接引导成交订单金额
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单金额为直接引导成交订单金额" />
          </>
        ),
        width: 180,
        sorter: true,
        dataIndex: 'directiveIntroOrderValue',
        render: (data) => {
          return formatPrice(data);
        },
        sorter: true,
      },
      {
        title: (
          <>
            直接引导成交订单量
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单量为直接引导成交订单量" />
          </>
        ),
        width: 160,
        sorter: true,
        dataIndex: 'directiveIntroParentOrderNums',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            直接引导UV价值
            <IconTip title="直接引导成交订单金额/直接引导成交UV" />
          </>
        ),
        width: 160,
        sorter: true,
        dataIndex: 'directiveIntroUVValue',
        render: (data) => {
          return formatPrice(data);
        },
      },
    ];
    if (statisticsDimension == '1') {
      columns.splice(2, 1);
    }
    return columns;
  };
  const expandedRowRender = (item) => {
    // const _columns = columns.slice();
    return (
      <div style={{ margin: '-16px -16px -16px 50px' }}>
        <Table
          loading={floorLoading}
          columns={getfloorColumns()}
          dataSource={floorData}
          scroll={{ x: 2000 }}
          pagination={false}
          indentSize={200}
          rowKey={(record) => {
            return record.floorId + '' + record.floorName;
          }}
        />
      </div>
    );
  };

  return (
    <div className="participant-detail-act-com-bg">
      <ModuleTitle title="会场明细表">
        <div className="activity-detail-table-wrapper">
          <div className="activity-detail-table-wrapper-filter">
            <div style={{ width: '100%' }}>
              <FilterBoxes form={form} onFinish={onFinish}>
                <Form.Item name="activityIds" span={6} label="会场名称:">
                  <Select
                    allowClear={true}
                    showSearch
                    mode="multiple"
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                      (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="请选择"
                  >
                    {filterData.activityName.length > 0 &&
                      filterData.activityName.map((item, index) => (
                        <Select.Option key={index} value={item.value}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                <Form.Item name="dept" span={6} label="会场所属部门:">
                  <Cascader
                    fieldNames={{ label: 'name', value: 'value' }}
                    options={filterData.activityDept}
                    placeholder="请选择"
                    changeOnSelect
                  />
                </Form.Item>
                <Form.Item name="erpA" span={6} label="会场所属人ERP:">
                  <Select
                    allowClear={true}
                    showSearch
                    mode="multiple"
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                      (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="请选择"
                  >
                    {filterData.activityErp.length > 0 &&
                      filterData.activityErp.map((item, index) => (
                        <Select.Option key={index} value={item}>
                          {item}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </FilterBoxes>
            </div>

            <div style={{ marginLeft: '16px' }}>
              <Button
                type="primary"
                onClick={
                  () => setVisible(true)
                  //  downLoad({ downLoad: true, ...value, ...conditions })
                }
              >
                导出数据
              </Button>
            </div>
          </div>
          <Table
            style={{ marginTop: 16 }}
            columns={getColumns()}
            expandedRowKeys={[activityId]}
            dataSource={data.values}
            scroll={{ x: 3050 }}
            loading={loading}
            rowKey="activityId"
            expandable={{ expandedRowRender }}
            pagination={{
              total: data.total,
              current: conditions.pageNum,
              pageSize: conditions.pageSize,
              showQuickJumper: true,
            }}
            onChange={(pagination, filters, sorter, { action }) => {
              let _val = {};
              if (action == 'sort') {
                _val = {
                  orderBy: sorter.order && sorter.field,
                  sequence: sorter.order?.replace('end', ''),
                  pageNum: 1,
                };
              }
              if (action == 'paginate') {
                _val = { pageNum: pagination.current };
              }
              setConditions((conditions) => Object.assign({}, conditions, _val));
            }}
            onExpand={(expanded, record) => {
              if (expanded) {
                setFloorLoading(true);
                console.log('展开', record, expanded);
                setActivityId(record.activityId);
                queryFloorList({ activityId: record.activityId, isFloor: '1', download: false });
              } else {
                setActivityId(null);
                setFloorData([]);
              }
            }}
          />
        </div>
      </ModuleTitle>
      <Modal
        title="导出数据"
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        okText="导出"
        destroyOnClose
        onOk={() => {
          setVisible(false);
          downLoad({ type: downloadType, downLoad: true, ...value, ...conditions });
        }}
      >
        <Form.Item label="数据维度：">
          <Radio.Group
            onChange={(e) => {
              setDownloadType(e.target.value);
            }}
            value={downloadType}
          >
            <Radio value={1}>会场</Radio>
            <Radio value={2}>楼层</Radio>
          </Radio.Group>
        </Form.Item>
      </Modal>
    </div>
  );
}
